import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { FullScreenLoading } from "../common/FullScreenLoading";
import { CompleteVerifyContact } from "./CompleteVerifyContact";
import { ErrorVerification } from "./ErrorVerification";

export function VerifyContact() {
    const [loading, setLoading] = useState(true);
    const { contactId } = useParams();
    const [verified, setVerified] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        const verify = async () => {
            const response = await fetch(`/api/contact/${contactId}/verify`, {
                method: "PUT",
            });
            if (!response.ok) {
                setError(true);
                return;
            }
            setVerified(true);
            setLoading(false);
        };
        verify();
    }, []);

    if (error) {
        return (
            <ErrorVerification />
        );
    }

    if (loading) {
        return (
            <FullScreenLoading />
        );
    }

    if (verified) {
        // 承認が完了した場合
        return (
            <CompleteVerifyContact />
        );
    }

    return null;
}

